var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.value)+" "),_c('u-link',{attrs:{"href":_vm.value,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("访问")]),_vm._v(" "),_c('u-copy',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }